/**
 * This UI widget converts static bars in a table into a draggable and resizable bars.
 * 
 * Given a table with:
 * 
 * 	<div id="bartable">
 * 		<table>
 * 		...
 * 			<td>
 * 				<div class="rel">
 * 					<div class="bar">
 * 						<div class="grabber grabber-start"></div>
 * 						<div class="block first"></div>
 * 						<div class="block middle"></div>
 * 						<div class="block middle"></div>
 * 						<div class="block middle"></div>
 * 						<div class="block last"></div>
 * 						<div class="grabber grabber-end"></div>
 * 					</div>
 * 				</div>
 * 			</td>
 *  	...
 *  		<td>
 *  			<div class="rel"></div> <!-- possible drop target -->
 *  		</td>
 *  	...
 * 		</table>
 *  </div>
 * 
 * Calling:
 * 
 *  $('#bartable').tableBars();
 * 
 * Makes: 
 * 	1) the bar draggable, droppable into a different table cell's rel.
 *  2) the bar resizable, inserting or removing .block divs for each additional column 
 *  	this bar needs to span.
 *  
 * 
 * 
 * See also http://docs.jquery.com/UI_Developer_Guide#The_widget_factory
 * 
 */
// TODO: rename selector to class name
// TODO: options should rebind listeners
(function($){
	
	$.widget("ui.tableBars", {
		
		options: {
			dropTargetSelector: '.rel',
			actionElementSelector: '.bar-wrapper:not(.table-bars-pending-accept)',
			resizeSelector: '.grabber',
			resizeStartSelector: '.grabber-start',
			resizeEndSelector: '.grabber-end',
			isResizableSelector: '.bar-wrapper',
			isRepositionableSelector: '.bar-wrapper',
			isHorizontalRepositionOnlySelector: '',
			renderNewBarElement: function(dropTarget){
				return '<div class="bar-wrapper"><div class="bar"><div class="block first last"></div></div></div>';
			},
			dragSensitivityPx: 10,
			smartActionSensitivityMinWidthPx: 20,
			mouseMoveTimeoutMs: 50,
			handleStartsEarlier: true,
			
			// events
			barClick: function(event, actionElement){},
			barModify: function(event, actionElementHelper, actionElement){},
			drawNew: function(event, actionElementHelper){},
			resizeDropTargetDragOver: function(event, dropTarget){}, // TODO: use data like func below
			repositionDropTargetDragOver: function(event, data){}, // TODO: note somewhere that this will fire when you drag too far left, outside table
			
			// callbacks
			isValidDropTarget: function(dropTarget, actionElement){ return true; }
		},
		
		// drop targets
		lastHoveredDropTarget: null,
		lastHoveredTd: null, // may be different from above in case of hitting left edge
		
		// mouse drag/click differentiation
		mouseDownEvent: null,
		mouseDownElement: null,
		mouseDownElementType: null,
		
		// states
		readyToHandleMouseMove: true,
		resizing: false,
		repositioning: false,
		drawingNew: false,
		
		// row and column position cache arrays
		rowPositionsY: null,
		colPositionsX: null,
		
		// action
		actionElement: null,
		
		actionStartTd: null,
		actionStartTdX: null,
		actionStartTdY: null,
		
		actionStartDropTarget: null,
		
		actionElementHelper: null,		
		
		// resize
		resizingGrabber: null,
		resizeDirection: null,
		resizeBarNumBlocks: null,
		
		// reposition
		repositionStartColIndex: null,
		

		
		
		
		_create: function() {
			this.element.addClass('table-bars');
			this._bindActionMouseListeners();
			this._bindResizeMouseListeners();
			this._bindRepositionMouseListeners();
			this._bindDrawNewMouseListeners();
		},
		
		_bindActionMouseListeners: function(){
			var bars = this;
			this.element.mousedown(function(event){
				if(event.which != 1) return;
				bars.mousedown = true;
			});
			this.element.delegate(this.options.actionElementSelector, 'click', function(event){
				// trigger tableBarsBarClick
				bars._trigger('barClick', event, this);
			});
			this.element.delegate(this.options.actionElementSelector, 'mousedown', function(event){
				// prevent default browser element drag handler
				event.preventDefault();
			});
			$('body').mouseup(function(event){
				bars.mousedown = false;
				if(bars.resizing){
					bars.resizing = false;
					bars._onResizeEnd(event);
				}
				if(bars.repositioning){
					bars.repositioning = false;
					bars._onRepositionEnd(event);
				}
				if(bars.drawingNew){
					bars.drawingNew = false;
					bars._onDrawNewEnd(event);
				}
				bars.mouseDownEvent = null;
				bars.mouseDownElement = null;
				bars.mouseDownElementType = null;
			});
			this.element.mousemove(function(event){ 
				if(bars.mousedown){
					if(bars.readyToHandleMouseMove){
						bars.readyToHandleMouseMove = false;
						bars.mousemoveTimeout = setTimeout(function(){ bars.readyToHandleMouseMove = true; },
														   bars.options.mouseMoveTimeoutMs);
						bars._onMouseMove(event);
					}
				}
			});
		},
		
		_bindResizeMouseListeners: function(){
			var bars = this;
			this.element.delegate(this.options.resizeSelector, 'mousedown', function(event){	
				if(event.which != 1) return;
				if(!bars.repositioning && !bars.drawingNew && !bars.mouseDownElement){
					bars.mouseDownEvent = event;
					bars.mouseDownElement = $(this);
					bars.mouseDownElementType = 'grabber';
				}
			});
		},
		
		_bindRepositionMouseListeners: function(){
			var bars = this;
			this.element.delegate(this.options.actionElementSelector, 'mousedown', function(event){
				if(event.which != 1) return;
				if(!bars.resizing && !bars.drawingNew && !bars.mouseDownElement){
					bars.mouseDownEvent = event;
					bars.mouseDownElement = $(this);
					bars.mouseDownElementType = 'bar';
				}
			});
		},
		
		_bindDrawNewMouseListeners: function(){
			var bars = this;
			this.element.delegate(this.options.dropTargetSelector, 'mousedown', function(event){
				if(event.which != 1) return;
				if(event.target.localName === 'a'){
					return;
				}
				if(!bars.repositioning && !bars.resizing && !bars.mouseDownElement){
					bars.mouseDownEvent = event;
					bars.mouseDownElement = $(this);
					bars.mouseDownElementType = 'dropTarget';
					// start drawing new action
					bars.drawingNew = true;
					bars._onDrawNewStart();
				}
			});
		},
		
		_onMouseMove: function(event){
			var bars = this;
			if(bars.resizing){
				bars._onResizeMouseMove(event); 
			}else if(bars.repositioning){
				bars._onRepositionMouseMove(event); 
			}else if(bars.drawingNew){
				bars._onDrawNewMouseMove(event);
			}else{
				// start resizing or repositioning?
				if(!bars.mouseDownEvent) return;
				var mouseMovedX = Math.abs(bars._getMousePosition(bars.mouseDownEvent).left - bars._getMousePosition(event).left);
				var mouseMovedY = Math.abs(bars._getMousePosition(bars.mouseDownEvent).top - bars._getMousePosition(event).top);
				if(mouseMovedX > bars.options.dragSensitivityPx || mouseMovedY > bars.options.dragSensitivityPx){
					// if bar is very narrow, attempt to differentiate between resize and reposition
					var actionElement = null;
					if(bars.mouseDownElementType == 'bar'){
						actionElement = bars.mouseDownElement;
						if(!actionElement.is(bars.options.isRepositionableSelector)) return;
					}else if(bars.mouseDownElementType == 'grabber'){
						actionElement = bars.mouseDownElement.parents(bars.options.actionElementSelector);
						if(!actionElement.is(bars.options.isResizableSelector)) return;
					}
					var actionElementWidth = actionElement.width();
					if(actionElementWidth < bars.options.smartActionSensitivityMinWidthPx){
						if(mouseMovedX > mouseMovedY){
							// smart: start resizing
							bars.resizing = true;
							bars._onResizeStart();
						}else{
							// smart: start repositioning
							bars.repositioning = true;
							bars._onRepositionStart();
						}
					}else if(bars.mouseDownElementType == 'bar'){
						// typical: start repositioning
						bars.repositioning = true;
						bars._onRepositionStart();
					}else if(bars.mouseDownElementType == 'grabber'){
						// typical: start resizing
						bars.resizing = true;
						bars._onResizeStart();
					}
					
				}
			}
		},
		
		// TODO: this function only applies to resize and repos, rename the func TODO: what else is there?
		_onActionStart: function(){			
			// action
			if(this.mouseDownElement.is(this.options.actionElementSelector)){
				this.actionElement = this.mouseDownElement;
			}else{
				this.actionElement = this.mouseDownElement.parents(this.options.actionElementSelector);
			}
			
			this.actionStartTd = this.actionElement.parents('td');
			this.actionStartTdX = this.actionStartTd.position().left;
			this.actionStartTdY = this.actionStartTd.position().top;
			
			this.lastHoveredDropTarget = this.actionStartTd.children(this.options.dropTargetSelector);
			this.actionStartDropTarget = this.lastHoveredDropTarget;
			
			// add a helper bar to the DOM
			this._initHelper();
			
			// remember row and column positions
			var bars = this;
			this.rowPositionsY = new Array();
			this.colPositionsX = new Array();
			this.element.find('tr').each(function(){
				var y = $(this).offset().top;
				bars.rowPositionsY.push(y == 0 ? null : y);
			});
			this.element.find('tr').first().find('td,th').each(function(){
				var x = $(this).offset().left;
				bars.colPositionsX.push(x == 0 ? null : x);
			});
		},
		
		_onResizeStart: function(){
			this._onActionStart();
			this.resizingGrabber = this.mouseDownElement;
			if(this.actionElement.find('.block').size() == 1){
				this.resizeDirection = 'expand-out';
			}else{
				this.resizeDirection = this.resizingGrabber.hasClass('grabber-start') ? 'left' : 'right';
			}			
			this.resizeBarNumBlocks = this.actionElement.find('.block').size();
			// styles
			this.element.addClass('table-bars-resizing');
			this.actionElement.addClass('table-bars-resizing');
			this.actionElementHelper.addClass('table-bars-resizing');
			// announce
			this._trigger('resizeStart', this.actionElement, this.actionElementHelper);
		},
		
		_onResizeMouseMove: function(event){
			var hoverTd = this._getHoverTd(event);
			if(!hoverTd) return;
			//this.element.find('.highlight').removeClass('highlight');
			//hoverTd.addClass('highlight');
			// only continue if hover cell changed
			var hoverDropTarget = hoverTd.find(this.options.dropTargetSelector);
			if(hoverDropTarget[0] == this.lastHoveredDropTarget[0]) return;
			this.lastHoveredDropTarget = hoverDropTarget;
			// column difference
			var hoverTdIndex = hoverTd.parent().children().index(hoverTd);
			if(hoverTdIndex == -1) return;
			var actionStartTdIndex = this.actionStartTd.parent().children().index(this.actionStartTd);
			var colsDiff = hoverTdIndex - actionStartTdIndex;
			// constrain size
			if(this.resizeDirection == 'left' && colsDiff > this.resizeBarNumBlocks-1) return;
			if(this.resizeDirection == 'right' && colsDiff < 0) return;
			// external function
			this._trigger('onResizeDropTargetDragOver', event, hoverDropTarget);
			// constrain drop target to row
			var actionStartTrIndex = this.element.find('tr').index(this.actionStartTd.parents('tr'));
			var hoverTdSameRow = $($(this.element.find('tr')[actionStartTrIndex]).find('td')[hoverTdIndex]);
			// resize helper
			var newNumBlocks = null;
            var	maxBlock = parseInt(this.actionElementHelper.attr('max-block'),10);
            var blockSpan = parseInt(this.actionElementHelper.attr('block-span'),10);

			if(this.resizeDirection == 'left'){
				newNumBlocks = this.resizeBarNumBlocks - colsDiff;
			}else if(this.resizeDirection == 'right'){
				newNumBlocks = colsDiff+1;
			}else if(this.resizeDirection == 'expand-out'){
				if(hoverTdIndex > actionStartTdIndex){
					newNumBlocks = colsDiff+1;
				}else{
					newNumBlocks = this.resizeBarNumBlocks - colsDiff;
				}
                if(newNumBlocks > maxBlock) {
                    newNumBlocks = maxBlock;
                }
			}

			var spanRatio = newNumBlocks / blockSpan;
			// Making sure the new block only move when the block span ratio is meet
            if ((spanRatio % 1) != 0) {
                return false;
            }
            newNumBlocks = Math.ceil(spanRatio * blockSpan);
			// Making sure the new block doesn't fall below the number block span allowed
            if(newNumBlocks < blockSpan) {
            	newNumBlocks = blockSpan;
			}
			var blockContainer = this.actionElementHelper.find('.block').parent();
			blockContainer.children().remove();
			for(var i=0; i<newNumBlocks; i++){
				var classes='block';
				if(i==0) classes += ' first';
				if(i==newNumBlocks-1) classes += ' last';
				if(i!=0 && i!=newNumBlocks-1) classes += ' middle';
				blockContainer.append('<div class="'+classes+'"></div>');
			}
			// move helper if needed
			if(this.resizeDirection == 'left'){
				this.actionElementHelper.appendTo(hoverTdSameRow.find(this.options.dropTargetSelector));
			}else if(this.resizeDirection == 'expand-out'){
				if(hoverTdIndex > actionStartTdIndex){
					this.actionElementHelper.appendTo(this.actionStartDropTarget);
				}else{
					this.actionElementHelper.appendTo(hoverTdSameRow.find(this.options.dropTargetSelector));
				}
			}

            this.actionElementHelper.removeClass (function (index, className) {
                return (className.match (/(^|\s)slot-taken-\S+/g) || []).join(' ');
            });
            if(!this.actionElementHelper.parents('.scrollable').is('.time-based') && !this.actionElementHelper.parents('tr:first').is('.events-row')) {
                newNumBlocks--;
            }
            this.actionElementHelper.addClass('slot-taken-' + newNumBlocks);

			// announce
			this._trigger('resizeMouseMove', this.actionElement, this.actionElementHelper);
		},
		
		_onResizeEnd: function(){
			// remove resizing styles
			this.element.removeClass('table-bars-resizing');
			this.actionElement.removeClass('table-bars-resizing');
			
			// make sure the original and new are different
			if(this.actionElement.find('.block').size() == this.actionElementHelper.find('.block').size() && 
			   this.actionElement.parent()[0] == this.actionElementHelper.parent()[0]){
				// not different, ignore
				this.actionElement.removeClass('table-bars-resizing');
				this.actionElementHelper.remove();
				return;
			}
			
			// add pending styles
			this.actionElement.addClass('table-bars-pending-accept');
			this.actionElementHelper.addClass('table-bars-pending-accept');
			
			// external function decides whether to accept or reject
			this.actionElementHelper.data('actionElement', this.actionElement);
			this._trigger('barModify', null, {
				actionElementHelper: this.actionElementHelper, 
				actionElement: this.actionElement,
				type: 'resize',
				grabber: this.resizingGrabber,
				resizeDirection: this.resizeDirection
			});
			
			// announce
			this._trigger('resizeEnd', this.actionElement, this.actionElementHelper);
		},
		
		_onRepositionStart: function(){
			this._onActionStart();
			// reposition
			var mouseDownHoverTd = this._getHoverTd(this.mouseDownEvent);
			if(mouseDownHoverTd){
				this.repositionColOffset = mouseDownHoverTd.parent().children().index(mouseDownHoverTd) - 
					this.actionStartTd.parent().children().index(this.actionStartTd);
			}else{
				this.repositionColOffset = 0;
			}
			this.lastHoveredTd = mouseDownHoverTd;
			this.startingTd = this.lastHoveredTd;
			// styles
			this.element.addClass('table-bars-repositioning');
			this.actionElement.addClass('table-bars-repositioning');
			this.actionElementHelper.addClass('table-bars-repositioning');
			// announce
			this._trigger('repositionStart', this.actionElement, this.actionElementHelper);
		},

		// TODO: rename variables for clarity, it's unclear which drop targets are under the mouse and which are holding the bar
		_onRepositionMouseMove: function(event){
			var hoverTd = this._getHoverTd(event);
			if(!hoverTd) return;
			// offset hoverTd by repositionStartColIndex
			var hoverTdIndex = hoverTd.parent().children().index(hoverTd);
			if(hoverTdIndex == -1) return;
			var dropTargetTdIndex = hoverTdIndex - this.repositionColOffset;
			
			// If this is a horizontal only move, then don't allow row moves
			if(this.actionElement.is(this.options.isHorizontalRepositionOnlySelector) && hoverTd.parents('tr').index() != this.startingTd.parents('tr').index())
				return;
			
			if(dropTargetTdIndex < 0){
				dropTargetTdIndex = 0;
			}
			var dropTargetTd = $(hoverTd.parent().children()[dropTargetTdIndex]);
			if(!dropTargetTd) dropTargetTd = hoverTd;
			// only continue if hover cell changed
			if(this.lastHoveredTd.size() != 1) throw 'IllegalState: lastHoveredTd must not be null, cannot compare with current';
			if(this.lastHoveredTd[0] == hoverTd[0]){
				return;
			}
			var lastHoveredTd = this.lastHoveredTd; // use for this time
			this.lastHoveredTd = hoverTd; // set for next time
			// compress or stretch (if enabled)
			if(this.options.handleStartsEarlier){
				var numColsStartsEarlier = null;
				var numColsStartsEarlierAttr = this.actionElementHelper.attr('numColsStartsEarlier');
				if(numColsStartsEarlierAttr && parseInt(numColsStartsEarlierAttr)){
					numColsStartsEarlier = parseInt(numColsStartsEarlierAttr);
				}else{
					numColsStartsEarlier = 0;
				}
				
				var leftEdgeAmountOver = hoverTdIndex - this.repositionColOffset - numColsStartsEarlier;
				var touchingLeftEdge = leftEdgeAmountOver <= 0;
				
				// compare col indexes with last to see if moved left or right
				var lastHoveredTdIndex = lastHoveredTd.parent().children().index(lastHoveredTd);
				
				var compress = false;
				var stretch = false;
				var compressOrStretchNumCols = 0;
				
				var blocks = this.actionElementHelper.find('.block');
				
				if(hoverTdIndex > lastHoveredTdIndex && numColsStartsEarlier > 0){
					stretch = true;
					compressOrStretchNumCols = hoverTdIndex - lastHoveredTdIndex;
					if(compressOrStretchNumCols > numColsStartsEarlier) compressOrStretchNumCols = numColsStartsEarlier;
					
				}else if(hoverTdIndex < lastHoveredTdIndex && leftEdgeAmountOver < 0 && blocks.size() > 1){
					compress = true;
					compressOrStretchNumCols = lastHoveredTdIndex - hoverTdIndex;
					if(compressOrStretchNumCols > blocks.size() - 1) compressOrStretchNumCols = blocks.size() - 1;
				}
				
				// add or remove blocks
				if(compress || stretch){ 
					var bar = this.actionElementHelper.find('.bar');
					for(var i=0; i<compressOrStretchNumCols; i++){
						if(stretch){
							bar.append('<div class="block"></div>');
							numColsStartsEarlier--;
							this.repositionColOffset++;
						}else{
							bar.find('.block').first().remove();
							numColsStartsEarlier++;
							this.repositionColOffset--;
						}
					}
					bar.find('.first').removeClass('first');
					bar.find('.last').removeClass('last');
					bar.find('.block').first().addClass('first');
					bar.find('.block').last().addClass('last');

					// and update attribute
					this.actionElementHelper.attr('numColsStartsEarlier', numColsStartsEarlier);
				}
				
				// if stretching keep at left edge
				if(stretch){
					// stretching
					dropTargetTdIndex = 0;
					dropTargetTd = $(hoverTd.parent().children()[0]);
				}
				
			}
			
			// only move if drop target changed (typical case)
			var hoverDropTarget = dropTargetTd.find(this.options.dropTargetSelector);
			if(this.lastHoveredDropTarget.size() != 1) throw 'IllegalState: lastHoveredDropTarget must not be null, cannot compare with current';
			if(!compress && !stretch && hoverDropTarget[0] == this.lastHoveredDropTarget[0]){
				return;
			}
			var lastHoveredDropTarget = this.lastHoveredDropTarget; // use for this time
			// only continue if drop target is valid
			if(!this.options.isValidDropTarget(hoverDropTarget, this.actionElement)){
				return false;
			}
			this.lastHoveredDropTarget = hoverDropTarget; // set for next time
			
			// external function
			this._trigger('repositionDropTargetDragOver', event, {
				dropTarget: hoverDropTarget, 
				lastDropTarget: lastHoveredDropTarget, 
				actionElementHelper: this.actionElementHelper
			});
			// move helper if needed
			this.actionElementHelper.appendTo(dropTargetTd.find(this.options.dropTargetSelector));
			// announce
			this._trigger('repositionMouseMove', this.actionElement, this.actionElementHelper);
		},
		
		_onRepositionEnd: function(){
			// remove repositioning styles
			this.element.removeClass('table-bars-repositioning');
			this.actionElement.removeClass('table-bars-repositioning');
			
			// make sure the original and new are different
			if(this.actionElement.parent()[0] == this.actionElementHelper.parent()[0]){
				// edge case - starts earlier
				if(this.options.handleStartsEarlier &&
				   this.actionElement.attr('numColsStartsEarlier') != this.actionElementHelper.attr('numColsStartsEarlier')){
					// same drop target but different "num cols starts earlier" values
					
				// typical case
				}else{
					// not different, ignore
					this.actionElement.removeClass('table-bars-repositioning');
					this.actionElementHelper.remove();
					return;
				}
			}
			
			// add pending styles
			this.actionElement.addClass('table-bars-pending-accept');
			this.actionElementHelper.addClass('table-bars-pending-accept');
			
			// announce
			this._trigger('repositionEnd', this.actionElement, this.actionElementHelper);
			
			// external function decides whether to accept or reject
			this.actionElementHelper.data('actionElement', this.actionElement);
			this._trigger('barModify', null, {
				actionElementHelper: this.actionElementHelper, 
				actionElement: this.actionElement,
				type: 'reposition'
			});
		},
		
		_onDrawNewStart: function(){
			// styles
			this.element.addClass('table-bars-drawing-new');
			// remember row and column positions -- TODO: DRY
			var bars = this;
			this.rowPositionsY = new Array();
			this.colPositionsX = new Array();
			this.element.find('tr').each(function(){
				var y = $(this).offset().top;
				if(y == 0 || !$(this).is(':visible')){
					y = null;
				}
				bars.rowPositionsY.push(y);
			});
			this.element.find('tr').first().find('td,th').each(function(){
				var x = $(this).offset().left;
				bars.colPositionsX.push(x == 0 ? null : x);
			});
			// get the td the mouse is over
			this.actionStartTd = this._getHoverTd(this.mouseDownEvent);
			this.actionStartDropTarget = this.actionStartTd.children(this.options.dropTargetSelector);
			this.lastHoveredDropTarget = this.actionStartDropTarget;
			// create and append helper
			this.actionElementHelper = $(this.options.renderNewBarElement(this.actionStartDropTarget)).appendTo(this.actionStartDropTarget);
			this.actionElementHelper.addClass('table-bars-helper').addClass('table-bars-drawing-new');
			// announce
			this._trigger('drawNewStart', null, this.actionElementHelper);
		},
		
		_onDrawNewMouseMove: function(event){
			var hoverTd = this._getHoverTd(event);
			if(!hoverTd) return;
			// TODO: code reuse
			var hoverDropTarget = hoverTd.find(this.options.dropTargetSelector);
			if(hoverDropTarget[0] == this.lastHoveredDropTarget[0]) return;
			this.lastHoveredDropTarget = hoverDropTarget;
			// column difference
			var hoverTdIndex = hoverTd.parent().children().index(hoverTd);
			if(hoverTdIndex == -1) return;
			var actionStartTdIndex = this.actionStartTd.parent().children().index(this.actionStartTd);
			var colsDiff = hoverTdIndex - actionStartTdIndex;
			// constrain drop target to row
			var actionStartTrIndex = this.element.find('tr').index(this.actionStartTd.parents('tr'));
			var hoverTdSameRow = $($(this.element.find('tr')[actionStartTrIndex]).find('td')[hoverTdIndex]);
			// resize helper
			var newNumBlocks = null;
			if(hoverTdIndex > actionStartTdIndex){
				newNumBlocks = colsDiff+1;
			}else{
				newNumBlocks = 1 - colsDiff;
			}
			var blockContainer = this.actionElementHelper.find('.block').parent();
			blockContainer.children().remove();
			for(var i=0; i<newNumBlocks; i++){
				var classes='block';
				if(i==0) classes += ' first';
				if(i==newNumBlocks-1) classes += ' last';
				if(i!=0 && i!=newNumBlocks-1) classes += ' middle';
				blockContainer.append('<div class="'+classes+'"></div>');
			}
			// move helper if needed
			if(hoverTdIndex > actionStartTdIndex){
				this.actionElementHelper.appendTo(this.actionStartDropTarget);
			}else{
				this.actionElementHelper.appendTo(hoverTdSameRow.find(this.options.dropTargetSelector));
			}
            this.actionElementHelper.removeClass (function (index, className) {
                return (className.match (/(^|\s)slot-taken-\S+/g) || []).join(' ');
            });
			if(!this.actionElementHelper.parents('.scrollable').is('.time-based') && !this.actionElementHelper.parents('tr:first').is('.events-row')) {
				newNumBlocks--;
			}
            this.actionElementHelper.addClass('slot-taken-' + newNumBlocks);
			// announce
			this._trigger('drawNewMouseMove', null, this.actionElementHelper);
		},
		
		_onDrawNewEnd: function(){
			// styles
			this.element.removeClass('table-bars-drawing-new');
			this.actionElementHelper.addClass('table-bars-pending-accept');
			// announce
			this._trigger('drawNewEnd', null, this.actionElementHelper);
		},

		_getHoverTd: function(event){
			// get mouse relative to document
			var mouse = this._getMousePosition(event);
			// get td under mouse
			var hoverRowIndex = null;
			var hoverColIndex = null;
			for(var i in this.rowPositionsY){
				var y = this.rowPositionsY[i];
				if(y == null) continue;
                if(mouse.top > y && !$(this.element.find('tr')[i]).hasClass('collapsed')) {
                    hoverRowIndex = i;
                }
			}
			for(var i in this.colPositionsX){
				var x = this.colPositionsX[i];
				if(x == null) continue;
				if(mouse.left > x) hoverColIndex = i;
			}
			if(hoverRowIndex && hoverColIndex){
				return $($(this.element.find('tr')[hoverRowIndex]).find('td')[hoverColIndex]);
			}else{
				return null;
			}
		},
		
		// TODO: this function only applies to resize and repos, rename the func
		_initHelper: function(){
			this.actionElementHelper = this.actionElement.clone().appendTo(this.actionStartDropTarget);
			// add class
			this.actionElementHelper.addClass('table-bars-helper');
		},
		
		acceptModification: function(actionElementHelper){
			actionElementHelper = $(actionElementHelper);
			var actionElement = actionElementHelper.data('actionElement');
			
			// move & resize original, discard accepted helper
			var newPosition = actionElementHelper.parents(this.options.dropTargetSelector);
			actionElement.appendTo(newPosition);
			var newBlocks = actionElementHelper.find('.block');
			var oldBlocksContainer = actionElement.find('.block').parent();
			oldBlocksContainer.find('.block').remove();
			oldBlocksContainer.append(newBlocks);
			actionElement.removeClass('table-bars-pending-accept');
			actionElementHelper.remove();

			// announce
			this._trigger('acceptModification', actionElement, actionElementHelper);
		},
		
		rejectModification: function(actionElementHelper){
			actionElementHelper = $(actionElementHelper);
			var actionElement = actionElementHelper.data('actionElement');
			
			// restore original, discard rejected helper
			actionElement.removeClass('table-bars-pending-accept');
			actionElementHelper.remove();
			
			// announce
			this._trigger('rejectModification', actionElement, actionElementHelper);
		},
		
		acceptNew: function(actionElementHelper, newActionElement){
			$(actionElementHelper).parents(this.options.dropTargetSelector).append(newActionElement);
			$(actionElementHelper).remove();
		},
		
		rejectNew: function(actionElementHelper){
			if($(actionElementHelper).hasClass('table-bars-pending-accept')){
				$(actionElementHelper).remove();
			}
		},
		
		_getMousePosition: function(event){
			/* thanks quirksmode.org */
			var mouseX = 0;
			var mouseY = 0;
			if (event.pageX || event.pageY) {
				mouseX = event.pageX;
				mouseY = event.pageY;
			} else if (event.clientX || event.clientY) {
				mouseX = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
				mouseY = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
			}
			return {top: mouseY, left: mouseX};
		}
		
	});
	
})(jQuery);
